import { FC, ReactNode } from "react";

type PageWrapperProps = {
  children: ReactNode | ReactNode[];
  hidePadding?: boolean;
};

const PageWrapper: FC<PageWrapperProps> = ({ children, hidePadding }) => {
  return (
    <div className={` w-full flex-1 overflow-y-auto ${hidePadding ? "py-0" : "py-4 pt-8 px-4 mx-auto sm:px-6"}`}>
      {children}
    </div>
  );
};

export default PageWrapper;
